export default "__VITE_ASSET__UbvwhLWB__"